'use client'

import PropTypes from 'prop-types'
import MUIFade from '@mui/material/Fade'
import MUIBackdrop from '@mui/material/Backdrop'
import MUIModal from '@mui/material/Modal'
import MUIBox from '@mui/material/Box'
import MUIStack from '@mui/material/Stack'
import MUITypography from '@mui/material/Typography'
import { CloseIcon } from '@repo/ui/CloseIcon'
import MUIIconButton from '@mui/material/IconButton'

export const Modal = ({ open, handleClose, title, children, sx = {}, isConfirm = false }) => {
  return (
    <MUIModal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      data-testid="Modal"
      open={open}
      onClose={handleClose}
      closeAfterTransition
      slots={{ backdrop: MUIBackdrop }}
      slotProps={{
        backdrop: {
          timeout: 500
        }
      }}
      sx={{ zIndex: isConfirm ? 7000 : 1300 }}
    >
      <MUIFade in={open}>
        <MUIBox
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '800px',
            height: 'auto',
            bgcolor: 'background.paper',
            boxShadow: 24,
            borderRadius: '4px',
            p: 6,
            ...sx
          }}
        >
          <MUIStack direction="row" justifyContent="space-between" alignItems="center" sx={{ mt: 1, mb: 5 }}>
            <MUITypography variant="h5" sx={{ mt: 0, mb: 0 }}>
              {title}
            </MUITypography>
            <MUIIconButton
              aria-label="close"
              onClick={handleClose}
              sx={{ position: 'absolute', top: '24px', right: '24px' }}
            >
              <CloseIcon sx={{ fontSize: '16px' }} />
            </MUIIconButton>
          </MUIStack>

          {children}
        </MUIBox>
      </MUIFade>
    </MUIModal>
  )
}

Modal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func,
  title: PropTypes.string,
  children: PropTypes.node.isRequired,
  sx: PropTypes.object,
  isConfirm: PropTypes.bool
}
